module.exports = __webpack_public_path__ + "static/media/RaisingChildren_web_1_preview.ce381126.jpg";